module.exports = __webpack_public_path__ + "static/fonts/Mont-ExtraLight.179c8eb.ttf";